import React, { KeyboardEvent } from 'react'

import {
  AlignItems,
  Box,
  Display,
  FlexDirection,
  FontWeight,
  Icon,
  IconVariant,
  JustifyContent,
  Text,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'
import { WaveLinkHeaderContentBlock } from '@library/api-menu-experience'

type WaveLinkHeaderProps = {
  contentBlock: WaveLinkHeaderContentBlock
  onClick: () => void
}

const WaveLinkHeaderContainer = withCitrusTheme(Box, () => ({
  width: '100%',
  margin: '3rem auto -3rem',
  paddingLeft: '30px',
  paddingRight: '30px',
  '@media (max-width: 543px)': {
    paddingLeft: 0,
    paddingRight: 0,
  },
}))

const WaveLinkHeaderCard = withCitrusTheme(Box, () => ({
  width: '95%',
  height: '8rem',
  margin: '0.5rem auto',
  borderRadius: '3px',
  overflow: 'hidden',
  position: 'relative',
  '@media (min-width: 544px)': {
    width: '100%',
    height: '7rem',
    margin: '0.5rem auto 1rem',
  },
}))

const WaveLinkHeaderInfo = withCitrusTheme(Box, () => ({
  height: '100%',
  width: '90%',
  position: 'relative',
  paddingLeft: '1rem',
  '@media (min-width: 544px)': {
    paddingLeft: '2rem',
  },
}))

const ArrowRightWrapper = withCitrusTheme(Box, () => ({
  position: 'absolute',
  right: '1rem',
  width: '1rem',
  height: '100%',
  '@media (min-width: 544px)': {
    right: '1.5rem',
  },
}))

const onKeyPress = (onClick: () => void) => (event: KeyboardEvent<HTMLDivElement>) => {
  if (event.key === 'Enter' || event.key === ' ') {
    onClick()
  }
}

export const WaveLinkHeader = ({ contentBlock, onClick }: WaveLinkHeaderProps) => {
  const titleImage = contentBlock.headerImage[0]

  return (
    <WaveLinkHeaderContainer data-testid="wave-link-header-container">
      <WaveLinkHeaderCard
        data-testid="wave-link-header"
        display={Display.Flex}
        alignItems={AlignItems.Center}
        role="button"
        tabIndex={0}
        onClick={onClick}
        onKeyPress={onKeyPress(onClick)}
        style={{
          backgroundColor: contentBlock.backgroundColor,
          cursor: 'pointer',
        }}
      >
        <WaveLinkHeaderInfo
          data-testid="wave-link-info"
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          alignItems={AlignItems.FlexStart}
          justifyContent={JustifyContent.Center}
          style={{
            color: contentBlock.color,
          }}
        >
          {titleImage ? (
            <img
              src={titleImage.url}
              alt={titleImage.altText || contentBlock.title}
              style={{ width: 200, height: 'auto', objectFit: 'cover', zIndex: 1 }}
              data-testid="wave-link-header-image"
            />
          ) : null}
          <Text
            data-testid="wave-link-description"
            size={3}
            fontWeight={FontWeight.Normal}
            style={{ color: contentBlock.color, paddingTop: '0.5rem', marginBottom: 0 }}
          >
            {contentBlock.description}
          </Text>
        </WaveLinkHeaderInfo>
        <ArrowRightWrapper
          data-testid="arrow-right-wrapper"
          display={Display.Flex}
          alignItems={AlignItems.Center}
        >
          <Icon
            name="chevron_right"
            size={4}
            variant={IconVariant.Inherit}
            style={{ color: contentBlock.color }}
          />
        </ArrowRightWrapper>
      </WaveLinkHeaderCard>
    </WaveLinkHeaderContainer>
  )
}
